export default __webpack_public_path__ + "images/NC.cd368c9.png";